import React, { Component } from 'react'
import { observer } from 'mobx-react'
import XTab from './ReportQuestions/XTab'

@observer
class XTabs extends Component {
    render() {
        console.log(`XTabs`)
        const { reportStore, store, reportFilter, scrollBottom } = this.props
        // return reportStore.xTabs.map((xtab) => (
        //     <XTab key={xtab} xTabId={xtab} reportFilter={reportFilter} reportStore={reportStore} store={store} scrollBottom={scrollBottom}/>
        // ))
        return null
    }
}

export default XTabs
